import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import {
  passwordHasDigit,
  passwordHasUppercase,
  passwordHasLowercase,
  passwordHasSpecialChar,
  passwordHasWhitespace,
} from './password-validator';

export class CustomValidators {
  static requiredMinLength(minLength: number): ValidatorFn[] {
    return [Validators.required, Validators.minLength(minLength)];
  }
  static get email(): ValidatorFn[] {
    return [Validators.required, Validators.email];
  }

  static get strongPassword(): ValidatorFn[] {
    return [
      Validators.required,
      Validators.minLength(12),
      passwordHasDigit,
      passwordHasUppercase,
      passwordHasLowercase,
      passwordHasSpecialChar,
      passwordHasWhitespace,
    ];
  }
  static getpasswordMatchValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    // If controls are not found, don't validate
    if (!password || !confirmPassword) {
      return null;
    }

    // Important: only run this validator if the confirmPassword field itself is valid or only has the mismatch error
    if (confirmPassword.errors && !confirmPassword.errors['mismatch']) {
      return null;
    }

    // Set error on confirmPassword control if validation fails
    if (password.value !== confirmPassword.value) {
      confirmPassword.setErrors({ mismatch: true });
      return { mismatch: true }; // You can also return the error for the form group itself
    } else {
      // Clear the 'mismatch' error if validation passes
      confirmPassword.setErrors(null);
      return null;
    }
  };
}
